import { render, staticRenderFns } from "./sidebar-search.vue?vue&type=template&id=118f9e9c&"
import script from "./sidebar-search.vue?vue&type=script&lang=js&"
export * from "./sidebar-search.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports